import { nprogress } from '@mantine/nprogress';
import { useEffect } from 'react';

import { useDynamicRouter } from './useDynamicRouter';

const handleStartProgress = () => nprogress.start();
const handleCompleteProgress = () => nprogress.complete();

export const useAppProgressBar = () => {
  const { router } = useDynamicRouter({});

  useEffect(() => {
    router.events.on('routeChangeStart', handleStartProgress);
    router.events.on('routeChangeError', handleCompleteProgress);
    router.events.on('routeChangeComplete', handleCompleteProgress);
    return () => {
      router.events.off('routeChangeStart', handleStartProgress);
      router.events.off('routeChangeError', handleCompleteProgress);
      router.events.off('routeChangeComplete', handleCompleteProgress);
    };
  }, []);
};
